import React, { PureComponent } from 'react';
import ButtonConfirmar from './ButtonConfirmar'
import ButtonDenegar from './ButtonDenegar'
import ButtonEditar from './ButtonEditar'
import ButtonEliminar from './ButtonEliminar'
import ButtonExpandir from './ButtonExpandir'

class TablaRow extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { ingresoAjuste, ajuste, getCodigo, confirmarAjuste, editar, eliminarAjuste, expandirRow, claseFlecha, permisosUsuario, state, setEstaDesplegado, backColor, siNoConfirmacion } = this.props;

        let backgroundColor = "";
        let importeTotal = parseInt(ajuste.ImporteTotalPesos, 10) != 0 ? "$ " + ajuste.ImporteTotalPesos : "u$s " + ajuste.ImporteTotalDolares
        let fechaValor = ajuste.FechaValor != null ? ajuste.FechaValor.substring(8, 10) + '-' + ajuste.FechaValor.substring(5, 7) + '-' + ajuste.FechaValor.substring(0, 4) : null;
        let fechaImputacion = ajuste.FechaImputacion != null ? ajuste.FechaImputacion.substring(8, 10) + '-' + ajuste.FechaImputacion.substring(5, 7) + '-' + ajuste.FechaImputacion.substring(0, 4) : null;;
        const permisos = (permisosUsuario || {});
        let estadoAjuste = ajuste.Estado.toUpperCase();
        let tituloPopUp = undefined;
        let tituloButton1 = undefined;
        let tituloButton2 = undefined;
        let mostrarBotonEliminar = false;
        let mostrarBotonConfirmar = false;
        let mostrarBotonEdicion = permisos.Modificacion;
        let habilitaSiNoConfirmacion = false;
        let ajusteEstados = ingresoAjuste.ajusteEstados;
        let cargoEstados = ingresoAjuste.cargoEstados;

        if (parseInt(ajuste.ImporteTotalPesos, 10) < 0 || parseInt(ajuste.ImporteTotalDolares, 10) < 0) {
            importeTotal = importeTotal.replace("-", "(")
            importeTotal += ")"
        }

        //VER QUE ESTADOS MANEJA PARA ESTO
        switch (ajuste.Estado) {
            case "Anulado":
                mostrarBotonEdicion = false;
                backgroundColor = "#ea0921";
                break;
            case "Pend. Confirmación":
                tituloPopUp = "Confirmar o Denegar";
                tituloButton1 = "Confirmar";
                tituloButton2 = "Denegar";
                backgroundColor = "#03a6ff";
                mostrarBotonConfirmar = mostrarBotonEliminar = true;
                break;
            case "Confirmado":
                tituloPopUp = "Denegar o Restablecer el estado Pend. Confirmación";
                tituloButton1 = "Denegar";
                tituloButton2 = "Restablecer";
                backgroundColor = "#15ce67";
                mostrarBotonConfirmar = mostrarBotonEliminar = true;
                break;
            case "Enviado":
                mostrarBotonEdicion = false;
                backgroundColor = "#606060";
                break;
            case "Denegado":
                mostrarBotonEdicion = false;
                tituloPopUp = "Confirmar o Restablecer el estado Pend. Confirmación";
                tituloButton1 = "Confirmar";
                tituloButton2 = "Restablecer";
                backgroundColor = "#ec4f53";
                mostrarBotonConfirmar = mostrarBotonEliminar = true;
                break;
            case "Aceptado por la Administradora":
                mostrarBotonEdicion = false;
                estadoAjuste = "ACEPTADO";
                backgroundColor = "#177b3b";
                break;
            case "Rechazado por la Administradora":
                mostrarBotonEdicion = false;
                estadoAjuste = "RECHAZADO";
                backgroundColor = "#ab1b20";
                break;
            default:
                backgroundColor = "#ffffff";
                break;
        }

        if (ajuste.TipoMovimiento == "A") {
            habilitaSiNoConfirmacion = siNoConfirmacion[0].SINOCONFIRMACIONAJUSTES
        } else {
            habilitaSiNoConfirmacion = siNoConfirmacion[0].SINOCONFIRMACIONCARGOS
        }

        return (
            <tr className={"ingresoAjustesTableRowGrilla " + backColor}>
                <div className="ingresoAjustesTableCell ingresoAjustesTableCellTipoMovimiento">
                    <div className={"ingresoAjustesTableCellMotivoInsideDiv"}>
                        {ajuste.TipoMovimiento == "A" ? "Ajuste" : "Cargo"}
                    </div>
                </div>
                <div className="ingresoAjustesTableCell ingresoAjustesTableCellFechaValor">
                    <div className={"ingresoAjustesTableCellMotivoInsideDiv"}>
                        {fechaValor ? fechaValor : "-"}
                    </div>
                </div>
                <div className="ingresoAjustesTableCell ingresoAjustesTableCellFechaImputacion">
                    <div className={"ingresoAjustesTableCellMotivoInsideDiv"}>
                        {fechaImputacion ? fechaImputacion : "-"}
                    </div>
                </div>
                <div className="ingresoAjustesTableCell ingresoAjustesTableCellMotivo">
                    <div className={"ingresoAjustesTableCellMotivoInsideDiv"}>
                        {ajuste.Motivo ? ajuste.Motivo : "-"}
                    </div>
                </div>
                <div className="ingresoAjustesTableCell ingresoAjustesTableCellDebitoCredito">
                    <div className={"ingresoAjustesTableCellMotivoInsideDiv"}>
                        {ajuste.DebitoCredito == 0 ? "D" : "C"}
                    </div>
                </div>
                <div className="ingresoAjustesTableCell ingresoAjustesTableCellCuotas">
                    <div className={"ingresoAjustesTableCellMotivoInsideDiv"}>
                        -
                    </div>
                </div>
                <div className="ingresoAjustesTableCell ingresoAjustesTableCellImporteTotal">
                    <div className={"ingresoAjustesTableCellMotivoInsideDiv"}>
                        {importeTotal ? importeTotal : "-"}
                    </div>
                </div>
                <div className="ingresoAjustesTableCell ingresoAjustesTableCellEstado">
                    <div className={"ingresoAjustesTableCellMotivoInsideDiv"}>
                        <div className="ingresoAjustesEstado" style={{ backgroundColor: backgroundColor }}>
                            {estadoAjuste}
                        </div>
                    </div>
                </div>
                <div className="ingresoAjustesTableCell ingresoAjustesTableCellAcciones">
                    <div className={"ingresoAjustesTableCellMotivoInsideDiv"}>
                        {mostrarBotonEdicion &&
                            <ButtonEditar
                                ajuste={ajuste}
                                editar={editar} />
                        }
                        {permisos.Baja && mostrarBotonEliminar &&
                            <ButtonEliminar
                                ajuste={ajuste}
                                eliminarAjuste={eliminarAjuste}
                                usuarioModif={ingresoAjuste.executionContext.login} />
                        }
                        {permisos.Confirmacion && habilitaSiNoConfirmacion && mostrarBotonConfirmar &&
                            <ButtonConfirmar
                                ajuste={ajuste}
                                confirmarAjuste={confirmarAjuste}
                                getCodigo={getCodigo}
                                tituloPopUp={tituloPopUp}
                                tituloButton1={tituloButton1}
                                tituloButton2={tituloButton2}
                                ajusteEstados={ajusteEstados}
                                cargoEstados={cargoEstados} />
                        }
                    </div>
                </div>
                <div className="ingresoAjustesTableCell ingresoAjustesTableCellDropDownBtn">
                    <div className={"ingresoAjustesTableCellMotivoInsideDiv"}>
                        <ButtonExpandir
                            id={ajuste.Id}
                            setEstaDesplegado={setEstaDesplegado}
                            estaDesplegado={state.estaDesplegado}
                            expandirRow={expandirRow}
                            claseFlecha={claseFlecha} />
                    </div>
                </div>
            </tr>
        );
    }
}

export default TablaRow;